import logger from './utils/logger.js';

// Function: Pushes "eNews Subscription" event to dataLayer
// Specs:
// - This function should be called whenenever a user subscribes to the newsletter, on the checkout page, footer, lightbox, or account pages
// TODO: This function is not currently being used on the checkout page, but needs to be.
const dataLayerSubscription = (source) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'eNews Subscription',
        event_category: 'eNews Subscription',
        event_action: 'Subscribe',
        event_label: source,
        event_value: 1,
    });
    logger('eNews Subscription event sent', { category: 'analytics' });
};

export { dataLayerSubscription as d };
//# sourceMappingURL=subscription-blf7SMVl.js.map
